import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PopupComponent } from '@app/components/popup/popup.component';
import { RegistrationWorkflowFormsComponent } from '@app/modules/registration-workflow/registration-workflow-forms/registration-workflow-forms.component';
import { BaseService } from '@app/system/services/base.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';

@Component({
	selector: 'app-external-event-detail',
	templateUrl: './external-event-detail.component.html',
	styleUrls: ['./external-event-detail.component.scss']
})
export class ExternalEventDetailComponent implements OnInit {

	@Input() resourceDetail: any = {};
	@Input() popupRef: any = {};
	@Output() reloadResource = new EventEmitter();
	@Output() readLogEmit = new EventEmitter();

	currentUser;
	showCount = false;
	skillMPermission = false;
	constructor(
		public locale: LocaleService,
		private popup: MatDialog,
		public detectDevice: DetectDeviceService,
		public gfService: GlobalFunctionService,
		private baseService: BaseService
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		this.showCount = this.baseService.checkAccessControl(['REG001']);
		if (this.baseService.checkModuleAccess('M13')) {
			this.skillMPermission = true;
		}
		if (this.resourceDetail && this.resourceDetail.infoFields) {
			if (this.resourceDetail.infoFields.time) {
				this.resourceDetail.eventTime = this.gfService.dateFormat(this.resourceDetail.infoFields.time, 'shortTime');
			}
			if (this.resourceDetail.resourceTypeID && this.resourceDetail.resourceTypeID.key && this.resourceDetail.infoFields.startDate) {
				this.resourceDetail.eventDate = this.gfService.dateFormat(this.resourceDetail.infoFields.startDate, 'd');
				this.resourceDetail.eventMonth = this.gfService.dateFormat(this.resourceDetail.infoFields.startDate, 'MMM')
				const date: any = new Date(this.resourceDetail.infoFields.startDate);
				if (Date.now() > Date.parse(date)) {
					this.resourceDetail.datePassed = true;
				} else {
					this.resourceDetail.datePassed = false;
				}
			}
		}
	}

	requestForm(tabName: string, additionalInfo: any = {}) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: RegistrationWorkflowFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'requestRegistrationList'
					},
					{
						variableName: 'record',
						value: this.resourceDetail
					},
					{
						variableName: 'tabName',
						value: tabName
					}
				]
			},
			disableClose: true,
			autoFocus: false,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result && typeof result === 'object') {
				if (result.updated) {
					this.reloadResource.emit(true);
				}
			}
		});
	}

	embedLink() {
		if (navigator.onLine) {
			let url;
			if (this.resourceDetail.resourceTypeID) {
				if (this.resourceDetail.resource && this.resourceDetail.resource.link) {
					url = this.resourceDetail.resource.link;
				}
			}
			this.gfService.windowNavigate(url, '_blank');
		}
	}

	emitReadLog() {
		this.readLogEmit.emit(true);
	}
}
